import React, { useState } from 'react';
import { registroIniciar, mensajeError, errorCode } from '../../api/canalRegistro';

/**
 * Formulario de alta SUELTO del canal (Ann 2026-07-13): solo la tarjeta de precio +
 * correo + "Empieza hoy", sin la landing alrededor. Al enviar NO vuelve a la home:
 * inicia el registro y avanza al alta (onEmpezar). Mismo look que la tarjeta de la landing.
 */
const MINT = '#5fc9a8';
const MINTD = '#43b28f';
const MINTC = '#7fd6bb';

export default function CanalAltaForm({
  precio = '63€',
  periodo = '/mes',
  // A dónde ir tras iniciar el registro. Por defecto al alta del Club (NUNCA a la home).
  onEmpezar = (email) => { window.location.href = `/club-alta?email=${encodeURIComponent(email || '')}`; },
  // Ann 2026-07-13: al pulsar "Política de Privacidad" SÍ se va a la home (la landing,
  // donde se lee la privacidad). El "Empieza hoy" no; ese avanza al alta.
  onPrivacidad = () => { window.location.href = '/'; },
  maqueta = false,
}) {
  const [email, setEmail] = useState('');
  const [emailErr, setEmailErr] = useState(false);
  const [errTxt, setErrTxt] = useState('');
  const [enviando, setEnviando] = useState(false);
  const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const empezar = async () => {
    if (!emailOk) { setEmailErr(true); return; }
    if (maqueta) { onEmpezar(email); return; }
    setEnviando(true); setErrTxt('');
    try {
      await registroIniciar(email);
      onEmpezar(email); // avanza al alta, NO a la home
    } catch (err) {
      if (errorCode(err) === 'EMAIL_INVALIDO') setEmailErr(true);
      else setErrTxt(mensajeError(err));
      setEnviando(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 20,
      background: 'radial-gradient(120% 90% at 50% 0%,#0d2926 0%,#071a1a 70%)', fontFamily: "'Montserrat', system-ui, sans-serif" }}>
      <div style={{ width: '100%', maxWidth: 560, background: 'rgba(9,28,26,.72)', backdropFilter: 'blur(14px)',
        border: '1px solid rgba(255,255,255,.10)', borderRadius: 24, padding: '38px 40px', boxShadow: '0 40px 90px -30px rgba(0,0,0,.7)' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
          <span style={{ fontSize: 58, fontWeight: 800, color: '#fff', letterSpacing: '-.02em', lineHeight: 1 }}>{precio}</span>
          <span style={{ fontSize: 22, fontWeight: 500, color: '#9db8ac' }}>{periodo}</span>
        </div>
        <p style={{ margin: '18px 0 22px', fontSize: 18, color: '#cfe0dc', fontWeight: 500 }}>Cancela cuando quieras. Sin permanencia.</p>

        <form onSubmit={(e) => { e.preventDefault(); empezar(); }} noValidate style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', background: '#0b2523',
            border: `1px solid ${emailErr ? '#ff9b8a' : 'rgba(255,255,255,.12)'}`, borderRadius: 14, padding: '2px 16px' }}>
            <input type="email" value={email} disabled={enviando} className="cl-email-input"
              onChange={(e) => { setEmail(e.target.value.trim()); if (emailErr) setEmailErr(false); if (errTxt) setErrTxt(''); }}
              placeholder="Tu correo electrónico" aria-label="Tu correo electrónico" aria-invalid={emailErr}
              style={{ flex: 1, minWidth: 0, background: 'transparent', border: 0, outline: 'none', color: '#fff', fontFamily: 'inherit', fontSize: 16, padding: '16px 0' }} />
          </div>
          <button type="submit" disabled={enviando}
            style={{ border: 0, cursor: 'pointer', fontFamily: 'inherit', fontSize: 17, fontWeight: 700, color: '#06231c',
              background: `linear-gradient(135deg,${MINTC},${MINTD})`, padding: '17px 26px', borderRadius: 14,
              boxShadow: `0 14px 30px -10px ${MINT}88`, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 10, opacity: enviando ? 0.75 : 1 }}>
            {enviando ? 'Enviando…' : 'Empieza hoy'}
            {!enviando && (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#06231c" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
            )}
          </button>
        </form>
        {(emailErr || errTxt) && <p style={{ margin: '10px 2px 0', color: '#ffcf72', fontSize: 13.5, fontWeight: 600 }}>{errTxt || 'Introduce una dirección de correo electrónico válida.'}</p>}

        <p style={{ margin: '18px 0 0', textAlign: 'center', fontSize: 13, color: '#7ea19d' }}>
          Al continuar aceptas nuestra{' '}
          <a href="/privacidad" onClick={(e) => { e.preventDefault(); onPrivacidad(); }} style={{ color: MINTC, textDecoration: 'none' }}>Política de Privacidad</a>
        </p>
      </div>
    </div>
  );
}
